import { forwardRef } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import type { IconProps } from '@hivebrite/design-system/Icon';
import {
  IconCornerBottomRight,
  IconCornerBottomLeft,
  IconCornerTopRight,
  IconCornerTopLeft,
  IconSideBottom,
  IconSideLeft,
  IconSideRight,
  IconSideTop,
} from '@hivebrite/design-system/Icon';

import type {
  PositionHandler,
  ImagePosition,
} from 'hb-builder/components/BuilderComponents/single/PageImage/types';
import type { PageImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/pageImageItemAttributess';

import { getCursor, getGlobalPosition } from '../utils/styles';

const ICONS: Record<PositionHandler, (iconProps: IconProps) => JSX.Element> = {
  bottom: IconSideBottom,
  left: IconSideLeft,
  right: IconSideRight,
  top: IconSideTop,
  'corner-bottom-left': IconCornerBottomLeft,
  'corner-bottom-right': IconCornerBottomRight,
  'corner-top-left': IconCornerTopLeft,
  'corner-top-right': IconCornerTopRight,
};

const ICON_SIZE = 20;

interface HandlersProps {
  activeHandle: string | null;
  onMouseDown: any;
  positionHandler: PositionHandler;
  resizeValues: ImagePosition &
    Pick<PageImageItemAttributes, 'height' | 'width'>;
}

const Handlers = forwardRef<HTMLDivElement, HandlersProps>(
  ({ activeHandle, onMouseDown, positionHandler, resizeValues }, ref) => {
    const ResizeIcon = ICONS[positionHandler];

    return (
      <PositionWrapper
        data-testid="image-handler"
        height={ICON_SIZE}
        onMouseDown={onMouseDown}
        $position={positionHandler}
        ref={ref}
        width={ICON_SIZE}
      >
        {activeHandle === positionHandler && resizeValues && (
          <SizeIndications>
            {resizeValues.width}x{resizeValues.height}px
          </SizeIndications>
        )}
        <ResizeIcon size={ICON_SIZE} />
      </PositionWrapper>
    );
  },
);

export default Handlers;

const PositionWrapper = styled(Box)<{ $position: PositionHandler }>`
  color: white;
  position: absolute;
  ${getCursor}
  ${getGlobalPosition}
`;

const SizeIndications = styled(Box).attrs(() => ({
  backgroundColor: 'black',
  color: 'white',
  fontSize: '11px !important',
  p: '2px 5px',
}))`
  border-radius: 5px;
`;
